import React, { useEffect } from "react";
import { goBack } from "connected-react-router";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import I18n from "pages/_components/I18n";
import Loader from "pages/_components/Loader";
import { actions as echeckActions } from "reducers/echecks";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import { bool } from "prop-types";
import CesionSummaryBody from "./components/Summary";
import CesionSummaryMultipleBody from "./components/SummaryMultiple";

const CesionSummaryPage = ({ isDesktop }) => {
    const { cesionEcheqData: cesionData, echeqsToDoActions: echeqAction } = useSelector((state) => state.echecks);
    const { echeckTicket } = useSelector((state) => state.echecks);
    const { dispatch } = useConfirmTransaction(cesionData, echeckTicket, "echecks/action/cesion");
    const willCancel = cesionData?.cesionData?.cancelTransaction;

    useEffect(() => {
        if (isEmpty(echeqAction)) {
            dispatch(goBack());
        }
    }, [dispatch]);

    if (isEmpty(echeqAction)) {
        return <Loader />;
    }

    const getTitle = () => {
        if (willCancel) {
            return "payments.cancel.title";
        }
        if(echeqAction.action === "ANULATE-CESION"){
            return "echeck.anulate.cesion.multiple";
        }
        return echeqAction?.echeqList?.length > 1 ? "echeq.emit.cesion.multiple.echeq" : "echeq.emit.cesion.echeq";
    }

    const selectAction = () => {
        if (willCancel) {
            return echeckActions.cancelTransfer;
        }

        if (echeqAction?.action === "ANULATE-CESION") {
            return echeckActions.executeActionEcheqMultiple;
        }

        return echeckActions.cesionEcheq;
    }

    const getIdActivity = () => {
        if (echeqAction?.action === "ANULATE-CESION") {
            return "actions.echeqs.multiple.send";
        }
        return "cesion.echeq.activity";
    }

    return (
        <>
            <Notification scopeToShow="echecks/cesion/confirm" />
            <ResponsiveHeader id={getTitle()} />
            <MainContainer>
                <h2>
                    <I18n id="echecks.summary.cesion.confirm" />
                </h2>
                <div className="box px-md-7 pt-sm-0">
                    {echeqAction?.echeqList?.length == 1 && (<CesionSummaryBody
                        beneficiary={
                            cesionData?.cesionData?.idTransaction
                                ? cesionData?.cesionData?.beneficiary
                                : cesionData?.beneficiary
                        }
                        address={cesionData?.cesionData?.address}
                        reference={cesionData?.cesionData?.reference}
                        referencevalue={cesionData?.cesionData?.referencevalue}
                        echeqList={echeqAction?.echeqList}
                        isDesktop={isDesktop}
                    />)}
                    {echeqAction?.echeqList?.length > 1 && (<CesionSummaryMultipleBody
                        beneficiary={
                            cesionData?.cesionData?.idTransaction
                                ? cesionData?.cesionData?.beneficiary
                                : cesionData?.beneficiary
                        }
                        address={cesionData?.cesionData?.address}
                        reference={cesionData?.cesionData?.reference}
                        referencevalue={cesionData?.cesionData?.referencevalue}
                        echeqList={echeqAction?.echeqList}
                        isDesktop={isDesktop}
                    />)}
                </div>
                <GeneralCredentialForm
                    hideIndications
                    transactionData={{ cesionData, echeqAction }}
                    action={selectAction()}
                    isCancel={willCancel}
                    idActivity={getIdActivity()}
                    disableContinueIfEmpty
                />
            </MainContainer>
        </>
    );
};

CesionSummaryPage.propTypes = {
    isDesktop: bool.isRequired,
};
export default CesionSummaryPage;
